import { defaultsConfig } from "~config/sport/defaults";
import { CompetitorTypes } from "~enums/competitorTypes";
import type { SportConfiguration } from "~types/sportConfiguration";

export const tennisConfig: SportConfiguration = {
  ...defaultsConfig,
  competitorType: CompetitorTypes.Person,
  maxParticipantCount: 2,
};
